<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    :class="variant == 'default' ? 'base-icon' : 'base-icon-white'"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      transform: `rotate(${rotate}deg)`,
    }"
    v-bind="$attrs"
    v-html="data"
  />
</template>

<script lang="ts">
import { defineComponent, PropType, toRefs } from 'vue';

import { useBaseIcon } from '@/hooks/use_base_icon';

export default defineComponent({
  name: 'BaseIcon',
  props: {

    /**
   * 表示するアイコン名
   */
    icon: {
      type: String,
      required: true,
    },

    variant: {
      type: String as PropType<'default' | 'white'>,
      default: 'default',
    },

    /**
   * 大きさ（px）
   */
    size: {
      type: Number,
      default: 16,
    },

    /**
   * 角度（deg）
   */
    rotate: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { icon } = toRefs(props);
    const data = useBaseIcon(icon);

    return {
      data,
    };
  },
});
</script>

<style lang="scss" scoped>
.BaseIcon {
  display: inline-block;

  // 普段はflexで中央添えすべきだが、そうではない環境でなるべく
  // 中央に近く載せてみる。
  vertical-align: middle;
  line-height: 1;
}
</style>

<style lang="scss">
// このCSSのおかげで、テキスト色でアイコン色が設定できる。
.base-icon svg {
  fill: currentColor;
  stroke: currentColor;
}

.base-icon-white svg {
  fill: white;
  stroke: white;
}
</style>
